module.exports = __webpack_public_path__ + "img/HEADER_CARRINHO_SIMPLIFICADO.b7db08c8.png";